import { Box, type BoxProps, Link, Text } from '@chakra-ui/react'
import React from 'react'
import config from '../../config'

export const Terms = (boxProps: BoxProps) => {
  return (
    <Box {...boxProps}>
      <Text align="center" fontSize="10px">
        By logging in, you agree to our{' '}
        <Link href={config.termsAndConditionsURL} color="#757575" isExternal>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link href={config.privacyPolicyURL} color="#757575" isExternal>
          Privacy Policy.
        </Link>
      </Text>
    </Box>
  )
}
